import React, { useEffect, useState } from "react";
import { Drawer, Box, Typography, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ResourcesGrid from "./ResourcesGrid";
import ChecksGrid from "./ChecksGrid";
import { useDispatch, useSelector } from "react-redux";
import { getComplianceResources, clearAllComplianceMessages } from "../../../store/compliance/complianceSlice";
import ErrorUI from "./ErrorUI";

const ControlResourcesDrawer = ({ open, onClose, controlId, resourcesUri, availableTypes, availableRegions, runId }) => {
  const dispatch = useDispatch();
  const { isGettingComplianceResources, getComplianceResourcesError, getComplianceResourcesMessage, complianceResources } = useSelector((state) => state.compliance);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('resources');
  const [selectedResource, setSelectedResource] = useState(null);

  useEffect(() => {
    if (open) {
      setView('resources');
      setSelectedResource(null);
    }
  }, [open, controlId, resourcesUri]);

  useEffect(() => {
    if (open && controlId && resourcesUri && runId) {
      setLoading(true);
      dispatch(getComplianceResources({ controlId, resourcesUri, runId }));
    }
  }, [open, controlId, resourcesUri, runId, dispatch]);

  useEffect(() => {
    if (getComplianceResourcesMessage || getComplianceResourcesError) {
      setLoading(false);
      dispatch(clearAllComplianceMessages());
    }
  }, [getComplianceResourcesMessage, getComplianceResourcesError, dispatch]);

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: 180, sm: 220, md: 600, lg: 900, xl: 1200 }, maxWidth: '100vw' } }}>
      <Box sx={{ p: 3, minHeight: '100vh', background: "#F9F9F9" }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {view === 'checks' && (
              <IconButton onClick={() => setView('resources')} size="small">
                <ArrowBackIcon />
              </IconButton>
            )}
            <Typography variant="h6" color="#333">
              {view === 'resources'
                ? <>Resources list for - <b>{`Control ${controlId}`}</b></>
                : <>Check list for - <b>{`${selectedResource?.ResourceArn || 'Resource'} | Control: ${controlId} | ${selectedResource?.Checks?.length || 0} ${(selectedResource?.Checks?.length || 0) === 1 ? 'check' : 'checks'}`}</b></>}
            </Typography>
          </Box>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>
        {view === 'resources' ? (
          loading || isGettingComplianceResources ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
              <CircularProgress color="primary" />
            </Box>
          ) : getComplianceResourcesError ? (
            <ErrorUI error={getComplianceResourcesError} onRetry={() => {
              setLoading(true);
              dispatch(getComplianceResources({ controlId, resourcesUri, runId }));
            }} />
          ) : !complianceResources || !complianceResources.Resources || complianceResources.Resources.length === 0 ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
              <Typography variant="h6" color="text.secondary">
                No resources data available
              </Typography>
            </Box>
          ) : (
            <ResourcesGrid 
              header={complianceResources} 
              resources={complianceResources.Resources} 
              availableTypes={availableTypes}
              availableRegions={availableRegions}
              onChecksClick={(resource) => {
                setSelectedResource(resource);
                setView('checks');
              }}
            />
          )
        ) : (
          <ChecksGrid checks={selectedResource?.Checks || []} />
        )}
      </Box>
    </Drawer>
  );
};

export default ControlResourcesDrawer; 